
<!-- SOLUTIONS & PARTNERS SUBHEADER LINKS -->
<section
  class="font-rubik w-full flex flex-col lg:flex-row justify-center lg:pb-[16px] lg:pt-20 border border-b border-gray-300 lg:border-0 bg-themeComponentBg-light"
>
  <div class="subheader-inner-container w-full max-w-1216 bg-white">
    <div class="relative">
      <!-- Cover Background Image -->
      <img
        :src="computedBackgroundImage"
        :alt="`${organization.name} background`"
        class="subheader-cover-img w-full lg:rounded-t-lg"
      />
    </div>

    <!-- Main content & navigation wrapper -->
    <div
      :class="[
        'tabs-container flex flex-col justify-between',
        { 'expended-min-height': !isExpanded && isMobile && fullTextText.length > 143 }
      ]"
    >
      <!-- Logos -->
      <div class="w-full flex flex-row justify-between h-[80px] lg:h-[105px]">
        <div class="subheader-logo-container">
          <img
            class="subheader-logo-img"
            :src="organizationLogo"
            :alt="organization.name"
          />
        </div>
        <div class="subheader-partner-logo-img">
          <span class="partner-badge" v-html="caBadgeSvg"></span>
        </div>
      </div>

      <!-- Heading & teaser -->
      <header class="w-full h-auto main-text-container">
        <h1 class="subheader-area-name pt-0 lg:pt-4 pb-2">
          {{ computedMainTitle }}
        </h1>

        <h2 v-if="organization.data['service_area']"
            class="subheader-serving-area pb-3">
          <template v-if="computedSubtitle">
            <span v-html="computedSubtitle"></span>
          </template>
          <template v-else>
            Serving container solutions at
            {{ organization.data['service_area'].trimEnd() }}.
          </template>
        </h2>

        <div class="subheader-serving-area">
          <template v-if="isMobile">
            <template v-if="isExpanded">
              <span v-html="fullTextHtml"></span>
            </template>
            <template v-else>
              {{ truncatedText }}
              <span v-if="!isExpanded && fullTextText.length > 143">
                <button
                  class="font-semibold"
                  @click.prevent="toggleExpand"
                >
                  read more…
                </button>
              </span>
            </template>
          </template>
          <template v-else>
            <span v-html="fullTextHtml"></span>
          </template>
        </div>
      </header>

      <!-- CTA & phone -->
      <div
        class="flex items-center lg:justify-start justify-between gap-4 flex-row-reverse lg:flex-row contact-button-container"
      >
        <button
          class="get-quote-button border rounded-full flex items-center justify-center"
          data-vue-init="lead-flow"
          data-props='{ "gtag": "get_quote"}'
          :style="{ backgroundColor: brandColor, borderColor: brandColor }"
        >
          <span class="text-white font-medium">Get Quote</span>
        </button>

        <a
          v-if="organization.phone"
          :href="`tel:${organization.data.phone}`"
          class="subheader-phone hidden lg:inline-block"
        >
          {{ formatPhoneNumber(organization.phone) }}
        </a>
        <a
          :href="`tel:${organization.data.phone}`"
          class="subheader-phone inline-block lg:hidden underline"
        >
          Call Us
        </a>
      </div>

      <!-- Desktop nav -->
      <nav
        class="hidden lg:flex lg:flex-row flex-col justify-between lg:items-center h-[44px]"
        aria-label="Primary"
      >
        <div class="hidden lg:flex items-center space-x-6 h-full">
          <!-- Static 'About' link -->
          <div
            :class="[
              'nav-link',
              isActive(aboutSlug) ? 'active' : '',
              'flex items-center px-3 h-full'
            ]"
            :style="isActive(aboutSlug) ? { '--active-color': brandColor } : {}"
          >
            <a
              :href="aboutSlug"
              class="subheader-nav-links mt-1"
              :style="
                isActive(aboutSlug)
                  ? { color: brandColor }
                  : { color: '#0c0e20' }
              "
            >
              About
            </a>
          </div>

          <!-- Dynamic solution links -->
          <div
            v-for="solution in solutionsArr"
            :key="solution.slug"
            :class="[
              'nav-link',
              isActive(solution.slug) ? 'active' : '',
              'flex items-center px-3 h-full'
            ]"
            :style="
              isActive(solution.slug)
                ? { '--active-color': brandColor }
                : {}
            "
          >
            <a
              :href="solution.slug"
              class="subheader-nav-links"
              :style="
                isActive(solution.slug)
                  ? { color: brandColor }
                  : { color: '#0c0e20' }
              "
            >
              {{ solution.title }}
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <!-- Mobile nav -->
  <nav
    class="flex flex-row justify-between lg:hidden text-gray-600 px-4 pt-8 bg-white"
    aria-label="Primary mobile"
  >
    <div
      v-for="link in mobileMainLinks"
      :key="link.slug"
      :class="[
        'nav-link',
        isActive(link.slug) ? 'active' : '',
        'flex items-center px-2 h-full'
      ]"
      :style="isActive(link.slug) ? { '--active-color': brandColor } : {}"
    >
      <a
        :href="link.slug"
        class="subheader-nav-links mt-1"
        :style="
          isActive(link.slug)
            ? { color: brandColor }
            : { color: '#0c0e20' }
        "
      >
        {{ link.label }}
      </a>
    </div>

    <!-- More dropdown -->
    <div v-if="mobileMoreLinks.length > 0">
      <Dropdown :page="moreDropdownPage" />
    </div>
  </nav>
</section>
